<template>
  <div class="modal">
    <transition name="modal">
      <div class="modal-mask">
        <div class="modal-wrapper">
          <div class="modal-container">

            <div class="modal-header">
              <slot name="header">
                <div class="title-md">
                  <div v-html="header" class="header-wrapper"></div>
                </div>
              </slot>
            </div>

            <div class="modal-body">
              <slot name="body">
                <div v-html="body" class="content-wrapper"></div>
              </slot>
            </div>

            <div class="modal-footer">
              <slot name="footer">
                <div class="footer-content-wrapper">
                  <button class="modal-default-button" @click="$emit('close')">
                    Close
                  </button>
                </div>
              </slot>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'modal',
  props: ['header', 'body']
}
</script>

<style scoped>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  width: 50%;
  margin: 0 auto;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  font-family: Helvetica, Arial, sans-serif;
}

@media only screen and (max-width: 700px) {
  .modal-container {
    width: 80%;
    margin-left: 65px;
  }

  .modal-body {
    overflow: auto;
    max-height: 350px;
  }
}

@media only screen and (max-height: 375px) {
  .modal-body {
    overflow: auto;
    max-height: 200px;
  }
}

.modal-header,
.modal-body {
  border-bottom: 1px solid #DDD;
}

.modal-body .content-wrapper {
  padding: 20px;
  max-height: 675px;
}

.modal-body .content-wrapper p {
  margin: 0 0 1em 0;
}

.modal-body {
  overflow: auto;
}

.footer-content-wrapper {
  display: flex;
  justify-content: flex-end;
  padding: 10px;
}

.footer-content-wrapper button {
  height: 2rem;
  line-height: 1rem;
}

.header-wrapper {
  background: #E9E9E9;
  padding: 20px;
}

/*
* The following styles are auto-applied to elements with
* transition="modal" when their visibility is toggled
* by Vue.js.
*
* You can easily play with the modal transition by editing
* these styles.
*/

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
</style>



// WEBPACK FOOTER //
// src/widgets/Modal.vue